
import { useParams, Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function ProductDetail() {
  const { id } = useParams();

  const products = [
    {
      id: 1,
      name: 'Professional Washer Extractor WE-35',
      brand: 'Wonder Clean India',
      category: 'Washer Extractors',
      capacity: '35 kg',
      features: ['High G-Force Extraction', 'Programmable Control', 'Stainless Steel Drum', 'Energy Efficient', 'Automatic Water Level Control', 'Multi-Language Display'],
      specifications: {
        'Capacity': '35 kg',
        'Extraction Speed': '650 RPM',
        'Motor Power': '3 HP',
        'Water Consumption': '180 L/cycle',
        'Dimensions': '1200 x 800 x 1100 mm',
        'Weight': '450 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Stainless Steel 304'
      },
      images: [
        '/images/products/washer-extractor-35kg-gallery-1.jpg',
        '/images/products/washer-extractor-35kg-gallery-2.jpg',
        '/images/products/washer-extractor-35kg-gallery-3.jpg'
      ],
      description: 'Heavy-duty washer extractor designed for commercial laundry operations with superior extraction performance. Built with premium stainless steel construction and advanced programmable controls for optimal washing results.',
      detailedDescription: 'The Professional Washer Extractor WE-35 represents the pinnacle of commercial laundry technology. Engineered for high-volume operations, this machine combines robust construction with intelligent automation to deliver consistent, superior washing results. The high G-force extraction system significantly reduces drying time, while the programmable control system allows for customized wash cycles tailored to different fabric types and soil levels.'
    },
    {
      id: 2,
      name: 'Industrial Tumble Dryer TD-50',
      brand: 'Electrolux Professional',
      category: 'Tumble Dryers',
      capacity: '50 kg',
      features: ['Gas/Electric Options', 'Moisture Sensing', 'Reversing Drum', 'Cool Down Cycle', 'Energy Recovery System', 'Anti-Wrinkle Function'],
      specifications: {
        'Capacity': '50 kg',
        'Drum Volume': '500 L',
        'Heating Power': '45 kW',
        'Motor Power': '2.2 kW',
        'Dimensions': '1400 x 900 x 1600 mm',
        'Weight': '380 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Galvanized Steel with Stainless Steel Drum'
      },
      images: [
        '/images/products/tumble-dryer-50kg-gallery-1.jpg',
        '/images/products/tumble-dryer-50kg-gallery-2.jpg',
        '/images/products/tumble-dryer-50kg-gallery-3.jpg'
      ],
      description: 'High-capacity tumble dryer with advanced moisture sensing technology for optimal drying results. Features energy-efficient operation and multiple heating options.',
      detailedDescription: 'The Industrial Tumble Dryer TD-50 sets new standards in commercial drying efficiency. With advanced moisture sensing technology, this dryer automatically adjusts cycle times to prevent over-drying, preserving fabric quality while maximizing energy efficiency. The reversing drum action ensures even drying and reduces tangling, while the energy recovery system captures and reuses heat for enhanced sustainability.'
    },
    {
      id: 3,
      name: 'Flat Work Ironer FWI-3200',
      brand: 'Stefab India',
      category: 'Flat Work Ironers',
      capacity: '3200 mm',
      features: ['Multi-Roll Design', 'Temperature Control', 'Variable Speed', 'Safety Systems', 'Steam Injection', 'Automatic Feeding'],
      specifications: {
        'Working Width': '3200 mm',
        'Roll Diameter': '800 mm',
        'Heating Power': '72 kW',
        'Production Rate': '15-25 m/min',
        'Dimensions': '4500 x 2000 x 1800 mm',
        'Weight': '2800 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Cast Iron Rolls with Chrome Plating'
      },
      images: [
        '/images/products/flat-work-ironer-gallery-1.jpg',
        '/images/products/flat-work-ironer-gallery-2.jpg',
        '/images/products/flat-work-ironer-gallery-3.jpg'
      ],
      description: 'Professional flat work ironer for high-volume pressing of sheets, towels, and flat textiles. Features precise temperature control and variable speed operation.',
      detailedDescription: 'The Flat Work Ironer FWI-3200 is engineered for maximum productivity in commercial laundry operations. Its wide 3200mm working width accommodates large items efficiently, while the multi-roll design ensures consistent pressure and temperature distribution. Advanced safety systems and automated feeding mechanisms make operation both safe and efficient, significantly reducing labor requirements while maintaining superior finish quality.'
    },
    {
      id: 4,
      name: 'Commercial Washer WX-25',
      brand: 'Alliance Laundry Systems',
      category: 'Washer Extractors',
      capacity: '25 kg',
      features: ['Side Loading', 'Programmable Controls', 'Water Recycling', 'Low Vibration', 'Automatic Dosing', 'Quick Wash Cycles'],
      specifications: {
        'Capacity': '25 kg',
        'Extraction Speed': '700 RPM',
        'Motor Power': '2.5 HP',
        'Water Consumption': '120 L/cycle',
        'Dimensions': '1000 x 700 x 1000 mm',
        'Weight': '320 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Stainless Steel 316'
      },
      images: [
        '/images/products/washer-25kg-gallery-1.jpg',
        '/images/products/washer-25kg-gallery-2.jpg',
        '/images/products/washer-25kg-gallery-3.jpg'
      ],
      description: 'Efficient commercial washer with side-loading design for easy operation and maintenance. Features water recycling system and low vibration operation.',
      detailedDescription: 'The Commercial Washer WX-25 combines ergonomic design with environmental consciousness. The side-loading configuration reduces operator fatigue and improves workflow efficiency, while the integrated water recycling system significantly reduces water consumption. Advanced vibration dampening technology ensures quiet operation, making it ideal for installations where noise levels are a concern.'
    },
    {
      id: 5,
      name: 'High Speed Dryer HSD-35',
      brand: 'Wonder Clean India',
      category: 'Tumble Dryers',
      capacity: '35 kg',
      features: ['Fast Drying', 'Energy Efficient', 'Lint Filter', 'Easy Maintenance', 'Digital Timer', 'Overheating Protection'],
      specifications: {
        'Capacity': '35 kg',
        'Drum Volume': '350 L',
        'Heating Power': '30 kW',
        'Motor Power': '1.8 kW',
        'Dimensions': '1200 x 800 x 1400 mm',
        'Weight': '280 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Powder Coated Steel with Stainless Steel Drum'
      },
      images: [
        '/images/products/high-speed-dryer-35kg-gallery-1.jpg',
        '/images/products/high-speed-dryer-35kg-gallery-2.jpg',
        '/images/products/high-speed-dryer-35kg-gallery-3.jpg'
      ],
      description: 'High-speed tumble dryer designed for rapid drying cycles and energy efficiency. Features advanced lint filtration and easy maintenance access.',
      detailedDescription: 'The High Speed Dryer HSD-35 is optimized for fast turnaround times without compromising fabric care. Its powerful heating system and efficient airflow design reduce drying times by up to 30% compared to conventional dryers. The advanced lint filtration system maintains optimal airflow while the easy-access maintenance points minimize downtime and service costs.'
    },
    {
      id: 6,
      name: 'Shirt Finishing Unit SFU-12',
      brand: 'Electrolux Professional',
      category: 'Finishing Equipment',
      capacity: '12 shirts/hour',
      features: ['Automated Pressing', 'Steam System', 'Ergonomic Design', 'Quality Finish', 'Sleeve Pressing', 'Collar Shaping'],
      specifications: {
        'Production Rate': '12 shirts/hour',
        'Steam Pressure': '4-6 bar',
        'Pressing Time': '15-25 seconds',
        'Power Consumption': '8 kW',
        'Dimensions': '1800 x 800 x 1600 mm',
        'Weight': '450 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Aluminum Pressing Forms'
      },
      images: [
        '/images/products/shirt-finishing-unit-gallery-1.jpg',
        '/images/products/shirt-finishing-unit-gallery-2.jpg',
        '/images/products/shirt-finishing-unit-gallery-3.jpg'
      ],
      description: 'Automated shirt finishing unit for professional garment pressing and finishing. Features steam system and ergonomic design for operator comfort.',
      detailedDescription: 'The Shirt Finishing Unit SFU-12 revolutionizes garment finishing with its fully automated pressing system. Precise steam injection and professionally designed forms ensure consistent, wrinkle-free results on every garment. The ergonomic design reduces operator fatigue while maintaining high productivity levels, making it ideal for dry cleaners and commercial laundries focused on garment quality.'
    },
    {
      id: 7,
      name: 'Washer Extractor WE-75',
      brand: 'Stefab India',
      category: 'Washer Extractors',
      capacity: '75 kg',
      features: ['Heavy Duty', 'High G-Force', 'Inverter Control', 'Water Saving', 'Automatic Unbalance Detection', 'Remote Monitoring'],
      specifications: {
        'Capacity': '75 kg',
        'Extraction Speed': '750 RPM',
        'Motor Power': '7.5 HP',
        'Water Consumption': '320 L/cycle',
        'Dimensions': '1600 x 1200 x 1400 mm',
        'Weight': '1200 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Stainless Steel 316L'
      },
      images: [
        '/images/products/washer-extractor-75kg-gallery-1.jpg',
        '/images/products/washer-extractor-75kg-gallery-2.jpg',
        '/images/products/washer-extractor-75kg-gallery-3.jpg'
      ],
      description: 'Heavy-duty washer extractor for high-volume commercial laundry operations. Features inverter control and water-saving technology.',
      detailedDescription: 'The Washer Extractor WE-75 is built for the most demanding commercial laundry environments. Its heavy-duty construction and high G-force extraction capabilities handle large loads efficiently while the inverter control system provides precise speed control and energy savings. Advanced unbalance detection and remote monitoring capabilities ensure reliable operation and minimize maintenance requirements.'
    },
    {
      id: 8,
      name: 'Steam Dryer SD-40',
      brand: 'Alliance Laundry Systems',
      category: 'Tumble Dryers',
      capacity: '40 kg',
      features: ['Steam Heating', 'Precise Control', 'Gentle Drying', 'Low Energy', 'Steam Injection', 'Wrinkle Prevention'],
      specifications: {
        'Capacity': '40 kg',
        'Drum Volume': '400 L',
        'Steam Pressure': '3-5 bar',
        'Motor Power': '2 kW',
        'Dimensions': '1300 x 850 x 1500 mm',
        'Weight': '320 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Stainless Steel Drum with Perforated Design'
      },
      images: [
        '/images/products/steam-dryer-40kg-gallery-1.jpg',
        '/images/products/steam-dryer-40kg-gallery-2.jpg',
        '/images/products/steam-dryer-40kg-gallery-3.jpg'
      ],
      description: 'Steam-heated dryer offering gentle and efficient drying for delicate fabrics. Features precise temperature control and low energy consumption.',
      detailedDescription: 'The Steam Dryer SD-40 represents the ultimate in fabric care technology. Steam heating provides gentle, even temperature distribution that preserves fabric integrity while achieving excellent drying results. The precision control system allows for customized drying profiles for different fabric types, while the steam injection feature helps reduce wrinkles and refreshes garments during the drying process.'
    },
    {
      id: 9,
      name: 'Conveyor Ironer CI-2500',
      brand: 'Wonder Clean India',
      category: 'Flat Work Ironers',
      capacity: '2500 mm',
      features: ['Continuous Operation', 'Heat Recovery', 'Adjustable Pressure', 'Quality Finish', 'Energy Saving', 'Safety Guards'],
      specifications: {
        'Working Width': '2500 mm',
        'Roll Diameter': '600 mm',
        'Heating Power': '45 kW',
        'Production Rate': '10-20 m/min',
        'Dimensions': '3500 x 1500 x 1600 mm',
        'Weight': '1800 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Cast Iron Rolls with Chrome Finish'
      },
      images: [
        '/images/products/conveyor-ironer-gallery-1.jpg',
        '/images/products/conveyor-ironer-gallery-2.jpg',
        '/images/products/conveyor-ironer-gallery-3.jpg'
      ],
      description: 'Conveyor ironer for continuous processing of flat work with heat recovery system. Features adjustable pressure and energy-saving operation.',
      detailedDescription: 'The Conveyor Ironer CI-2500 maximizes productivity through continuous operation design. The integrated heat recovery system captures and reuses thermal energy, reducing operating costs by up to 25%. Adjustable pressure settings accommodate different fabric weights and types, while comprehensive safety guards ensure operator protection during continuous operation cycles.'
    },
    {
      id: 10,
      name: 'Barrier Washer BW-60',
      brand: 'Electrolux Professional',
      category: 'Washer Extractors',
      capacity: '60 kg',
      features: ['Hygiene Barrier', 'Dual Doors', 'Contamination Control', 'Hospital Grade', 'Automatic Disinfection', 'HEPA Filtration'],
      specifications: {
        'Capacity': '60 kg',
        'Extraction Speed': '600 RPM',
        'Motor Power': '5 HP',
        'Water Consumption': '280 L/cycle',
        'Dimensions': '1500 x 1000 x 1300 mm',
        'Weight': '800 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Medical Grade Stainless Steel'
      },
      images: [
        '/images/products/barrier-washer-60kg-gallery-1.jpg',
        '/images/products/barrier-washer-60kg-gallery-2.jpg',
        '/images/products/barrier-washer-60kg-gallery-3.jpg'
      ],
      description: 'Barrier washer designed for healthcare facilities with contamination control features. Features dual doors and automatic disinfection cycles.',
      detailedDescription: 'The Barrier Washer BW-60 meets the strictest hygiene standards required in healthcare environments. The dual-door design creates a physical barrier between contaminated and clean areas, while automatic disinfection cycles eliminate pathogens. HEPA filtration and medical-grade stainless steel construction ensure complete contamination control, making it essential for hospitals, nursing homes, and medical facilities.'
    },
    {
      id: 11,
      name: 'Garment Conveyor GC-8M',
      brand: 'Stefab India',
      category: 'Accessories',
      capacity: '8 meters',
      features: ['Variable Speed', 'Heavy Duty', 'Modular Design', 'Easy Installation', 'Load Sensors', 'Emergency Stops'],
      specifications: {
        'Length': '8 meters',
        'Load Capacity': '200 kg',
        'Belt Width': '500 mm',
        'Motor Power': '1.5 kW',
        'Dimensions': '8000 x 600 x 1200 mm',
        'Weight': '450 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Powder Coated Steel Frame'
      },
      images: [
        '/images/products/garment-conveyor-gallery-1.jpg',
        '/images/products/garment-conveyor-gallery-2.jpg',
        '/images/products/garment-conveyor-gallery-3.jpg'
      ],
      description: 'Heavy-duty garment conveyor system for efficient workflow in commercial laundries. Features modular design and variable speed control.',
      detailedDescription: 'The Garment Conveyor GC-8M streamlines laundry workflow with its robust, modular design. Variable speed control adapts to different operational requirements while load sensors prevent overloading and ensure safe operation. The modular construction allows for easy expansion and reconfiguration, making it adaptable to changing facility layouts and requirements.'
    },
    {
      id: 12,
      name: 'Folding Machine FM-120',
      brand: 'Alliance Laundry Systems',
      category: 'Finishing Equipment',
      capacity: '120 pieces/hour',
      features: ['Automatic Folding', 'Size Detection', 'Stack Output', 'Easy Operation', 'Quality Control', 'Multi-Fold Patterns'],
      specifications: {
        'Production Rate': '120 pieces/hour',
        'Fold Types': '6 different patterns',
        'Maximum Size': '3000 x 2000 mm',
        'Power Consumption': '5 kW',
        'Dimensions': '4000 x 1500 x 1400 mm',
        'Weight': '1200 kg',
        'Power Supply': '415V, 3Ph, 50Hz',
        'Material': 'Stainless Steel Construction'
      },
      images: [
        '/images/products/folding-machine-gallery-1.jpg',
        '/images/products/folding-machine-gallery-2.jpg',
        '/images/products/folding-machine-gallery-3.jpg'
      ],
      description: 'Automatic folding machine with size detection and stack output for efficient processing. Features multiple fold patterns and quality control.',
      detailedDescription: 'The Folding Machine FM-120 revolutionizes textile finishing with intelligent automation. Advanced size detection technology automatically adjusts folding parameters for different item sizes, while multiple fold pattern options accommodate various textile types. The integrated quality control system ensures consistent results, and the organized stack output system streamlines the final processing stage.'
    }
  ];

  const product = products.find(p => p.id === parseInt(id || '0'));

  if (!product) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Product Not Found</h1>
          <Link to="/products">
            <Button variant="primary">Back to Products</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-8">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/products" className="hover:text-blue-600">Products</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">{product.name}</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="aspect-square rounded-2xl overflow-hidden bg-gray-100">
                <img
                  src={product.images[0]}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                {product.images.slice(1).map((image, index) => (
                  <div key={index} className="aspect-square rounded-xl overflow-hidden bg-gray-100">
                    <img
                      src={image}
                      alt={`${product.name} view ${index + 2}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Product Information */}
            <div className="space-y-6">
              <div>
                <div className="flex items-center space-x-3 mb-4">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {product.category}
                  </span>
                  <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">
                    {product.brand}
                  </span>
                </div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.name}</h1>
                <p className="text-xl text-gray-700 leading-relaxed mb-6">
                  {product.description}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {product.detailedDescription}
                </p>
              </div>

              {/* Key Features */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Key Features</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.features.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-6">
                <Link to="/contact" className="flex-1">
                  <Button variant="primary" size="lg" className="w-full">
                    <i className="ri-message-3-line mr-2"></i>
                    Get Quote
                  </Button>
                </Link>
                <Link to="/contact" className="flex-1">
                  <Button variant="outline" size="lg" className="w-full">
                    <i className="ri-phone-line mr-2"></i>
                    Contact Sales
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {/* Technical Specifications */}
          <div className="bg-gray-50 rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Technical Specifications</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {Object.entries(product.specifications).map(([key, value], index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="text-sm text-gray-600 font-medium mb-2">{key}</div>
                  <div className="text-lg font-bold text-gray-900">{value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Related Products */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Related Products</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {products
                .filter(p => p.category === product.category && p.id !== product.id)
                .slice(0, 3)
                .map((relatedProduct) => (
                  <Link key={relatedProduct.id} to={`/products/${relatedProduct.id}`}>
                    <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
                      <div className="aspect-square overflow-hidden">
                        <img
                          src={relatedProduct.images[0]}
                          alt={relatedProduct.name}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
                          {relatedProduct.name}
                        </h3>
                        <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                          {relatedProduct.description}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-blue-600 font-semibold">{relatedProduct.capacity}</span>
                          <span className="text-blue-600 font-medium group-hover:underline">
                            Learn More <i className="ri-arrow-right-line ml-1"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
